var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40.5,
    height: 40.5,
    viewBox: "0 0 40.5 40.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-users-2 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1875 18.5098C18.9009 18.5098 21.9111 15.4995 21.9111 11.7861C21.9111 8.07277 18.9009 5.0625 15.1875 5.0625C11.4741 5.0625 8.46387 8.07277 8.46387 11.7861C8.46387 15.4995 11.4741 18.5098 15.1875 18.5098Z",
    fill: "#0D44AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.7139 15.1875C31.5098 15.1875 33.7764 12.9209 33.7764 10.125C33.7764 7.32906 31.5098 5.0625 28.7139 5.0625C25.9179 5.0625 23.6514 7.32906 23.6514 10.125C23.6514 12.9209 25.9179 15.1875 28.7139 15.1875Z",
    fill: "#D3E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.0625 28.6348C5.0625 26.411 5.94589 24.2783 7.51834 22.7058C9.09079 21.1334 11.2235 20.25 13.4473 20.25H16.9277C19.1515 20.25 21.2842 21.1334 22.8567 22.7058C24.4291 24.2783 25.3125 26.411 25.3125 28.6348V30.375C25.3125 31.7177 24.7791 33.0053 23.8297 33.9547C22.8803 34.9041 21.5927 35.4375 20.25 35.4375H10.125C8.78234 35.4375 7.49467 34.9041 6.54527 33.9547C5.59587 33.0053 5.0625 31.7177 5.0625 30.375V28.6348Z",
    fill: "#D3E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.4374 21.9902C35.4374 20.6266 34.8957 19.3188 33.9315 18.3546C32.9672 17.3903 31.6595 16.8486 30.2958 16.8486H26.8154C26.0859 16.8487 25.3682 17.0321 24.7283 17.3821C24.0883 17.7321 23.5466 18.2374 23.153 18.8515C24.8653 19.8344 26.279 21.2634 27.2435 22.9862C28.208 24.709 28.6871 26.6612 28.6299 28.6348H32.1943C32.6202 28.6348 33.0419 28.5509 33.4354 28.3879C33.8288 28.2249 34.1864 27.986 34.4875 27.6849C34.7887 27.3837 35.0276 27.0262 35.1906 26.6327C35.3535 26.2392 35.4374 25.8175 35.4374 25.3916V21.9902Z",
    fill: "#0D44AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers2);
export default __webpack_public_path__ + "static/media/icon-users-2.e299d9d63587079e5e68e89dfcd0dc40.svg";
export { ForwardRef as ReactComponent };